"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _InputGroup = _interopRequireDefault(require("../FormControlFragments/InputGroup"));

var _excluded = ["ariaLabelledBy", "classes", "description", "descriptionId", "errorMessages", "groupFormControlId", "isDescriptionHtml", "isDisabled", "isHorizontal", "isOptional", "isValid", "legendLabel", "name", "radioItems"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RadioGroup = function RadioGroup(_ref) {
  var ariaLabelledBy = _ref.ariaLabelledBy,
      classes = _ref.classes,
      description = _ref.description,
      descriptionId = _ref.descriptionId,
      errorMessages = _ref.errorMessages,
      groupFormControlId = _ref.groupFormControlId,
      isDescriptionHtml = _ref.isDescriptionHtml,
      isDisabled = _ref.isDisabled,
      isHorizontal = _ref.isHorizontal,
      isOptional = _ref.isOptional,
      isValid = _ref.isValid,
      legendLabel = _ref.legendLabel,
      name = _ref.name,
      radioItems = _ref.radioItems,
      additionalProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_InputGroup.default, _extends({
    classes: classes,
    description: description,
    descriptionId: descriptionId,
    errorMessages: errorMessages,
    groupFormControlId: groupFormControlId,
    groupedItems: radioItems,
    isDescriptionHtml: isDescriptionHtml,
    isDisabled: isDisabled,
    isHorizontal: isHorizontal,
    isOptional: isOptional,
    isRadioGroup: true,
    isValid: isValid,
    legendLabel: legendLabel,
    name: name,
    ariaLabelledBy: ariaLabelledBy
  }, additionalProps));
};

RadioGroup.propTypes = {
  /**
   Optional. Adds `aria-labelledby` attribute to associate the input with a page level error message.
   */
  ariaLabelledBy: _propTypes.default.string,

  /**
   Optional. String to add custom class(es) to the component.
   */
  classes: _propTypes.default.string,

  /**
   Optional. Custom description that appears below the input group. Can be a string or a React component (object).
   */
  description: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({})]),

  /**
   Optional. A unique identifier passed to the description's `id` attribute. Defaults to `null`.
   */
  descriptionId: _propTypes.default.string,

  /**
   Optional. Array of error message strings displayed when `isValid` is `false`.
   */
  errorMessages: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   Required. Custom ID for group container. Needed to ensure proper keyboard functionality.
   */
  groupFormControlId: _propTypes.default.string.isRequired,

  /**
   Optional. Used to pass HTML to the `description` prop. Defaults to `false`.
   */
  isDescriptionHtml: _propTypes.default.bool,

  /**
   Optional. Passes the `disabled` prop to each radio input in the group. Defaults to `false`.
   */
  isDisabled: _propTypes.default.bool,

  /**
   Optional. Displays the radio options horizontally. Defaults to `false`.
   */
  isHorizontal: _propTypes.default.bool,

  /**
   Optional. Should not be used if `isRequired` is used. Adds "Optional" text to the right of the legend. Defaults to `false`.
   */
  isOptional: _propTypes.default.bool,

  /**
   Optional. Sets the error state for the component and it's radios when set to `false`. Defaults to `true`.
   */
  isValid: _propTypes.default.bool,

  /**
   Required. Legend text or description needed to properly group the fields.
   */
  legendLabel: _propTypes.default.string.isRequired,

  /**
   Required. The common `name` attribute for each input in the group.
   */
  name: _propTypes.default.string.isRequired,

  /**
   Required. The list of radio inputs as an array of objects with properties as props from the Radio component.
   */
  radioItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    handleOnChange: _propTypes.default.func.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.string.isRequired
  })).isRequired
};
RadioGroup.defaultProps = {
  ariaLabelledBy: null,
  classes: '',
  description: '',
  descriptionId: '',
  errorMessages: [],
  isDescriptionHtml: false,
  isDisabled: false,
  isHorizontal: false,
  isOptional: false,
  isValid: true
};
var _default = RadioGroup;
exports.default = _default;